import { lazy } from "react";

export { AI_TOKEN_USAGE_PATH } from "./path";
export const AiTokenUsagePage = lazy(() => import("./page"));
